module.exports = __webpack_public_path__ + "fonts/CrimsonText-Italic-4.7261d84f.ttf";